<script>
    import NavigationLink from './NavigationLink.svelte';
</script>

<style lang="scss" global>
	@import "./Navigation.scss";
</style>
<nav class="navigation">
    <NavigationLink route={{path: '/', name: 'Feed'}} />
    <NavigationLink route={{path: '/vault', name: 'Vault'}} />
    <NavigationLink route={{path: '/create', name: 'Create'}} />
    <NavigationLink route={{path: '/chat', name: 'Chat'}} />
    <NavigationLink route={{path: '/profile', name: 'Profile'}} />
</nav>